import {
  GraphData,
  GraphEdge,
  LaEdgeApiItem,
  LaEdgesResponse,
  LaNodeApiItem,
} from '../types';

export function getDefaultGraphData(): GraphData {
  return {
    nodes: [],
    edges: [],
    sourceNodeId: '',
  };
}

export function getDefaultLaEdgeApiItem(id: string): LaEdgeApiItem {
  return {
    id,
    depth: 1,
    sourceNodeId: id,
    sourceNodeType: '',
    sourceNodeValue: '',
    targetNodeId: id,
    targetNodeType: '',
    targetNodeValue: '',
    firstAccessed: '',
    lastAccessed: '',
    countInception: 1,
  };
}

export function getDefaultNodeApiItem(id: string): LaNodeApiItem {
  return {
    id,
    type: '',
    value: '',
    dataSource: '',
    firstAccessed: '',
    lastAccessed: '',
    ipState: '',
    ipCountry: '',
    ipIsp: '',
    isIpInEuropeanUnion: false,
  };
}

export function toEdgeGraphItem(edge: LaEdgeApiItem): GraphEdge {
  return {
    id: edge.id,
    depth: edge.depth,
    source: edge.sourceNodeId,
    target: edge.targetNodeId,
  };
}

export function getDefaultLaEdgesResponse(): LaEdgesResponse {
  return {
    depth: '1',
    limit: 0,
    total: 0,
    size: 0,
    content: [],
  };
}
